module.exports = __webpack_public_path__ + "static/media/settings.56c0776a.svg";